module.exports = __webpack_public_path__ + "c0d3dc9889d6ee8ecee9f05b0028ddd7.svg";